<template>
  <div class="center_box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-row>
        <el-col :span="22">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">{{$t('message.homepage')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item> -->
          <!-- <Header></Header> -->
          <div class="img_box">
            <img v-if="logo_cn" src="../../static/kefon_logo.png" alt="">
            <img v-if="logo_en" src="../../static/kefon_logo_en.png" alt="">
          </div>
        </el-col>
        <el-col :span="2">
          <!-- 中英文切换 -->
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              中文/English<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cn">Chinese</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-breadcrumb>

    <h1 style="font-size:30px;padding-top:20px;padding-bottom:20px;">{{$t('message.systemName')}}
      <span v-if="logo_cn" class="el-dropdown-link" style="font-size: 16px;color: red;" @click="openFile">
        {{$t('message.fileDownLoad')}} <i class="el-icon-arrow-down el-icon-download"></i>
      </span>
    </h1>
    
    <el-row :gutter="20" style="width:120%;">
      <router-link to="/electricMachine">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <img src="@/assets/elec_1.png" alt="">
            <h1>{{$t('message.title_01')}}</h1>
          </div>
        </el-col>
      </router-link>
      <router-link to="/loadSelection">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <img src="@/assets/load_1.png" alt="">
            <h1>{{$t('message.title_02')}}</h1>
          </div>
        </el-col>
      </router-link>
      <router-link to="/applicationSelection">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <img src="@/assets/application_1.png" alt="">
            <h1>{{$t('message.title_03')}}</h1>
          </div>
        </el-col>
      </router-link>
      <router-link to="/motorSelection">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <img src="@/assets/param_1.png" alt="">
            <h1>{{$t('message.title_04')}}</h1>
          </div>
        </el-col>
      </router-link>
      <router-link to="/momentInertia">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <img src="@/assets/turn_1.png" alt="">
            <h1>{{$t('message.title_05')}}</h1>
          </div>
        </el-col>
      </router-link>
    </el-row>
    <div class="tipsBox" v-if="showTipsBox">
      <span class="text">{{$t('message.ie_text')}}</span> <button @click="download()" class="download">{{$t('message.ie_download')}}</button>
    </div>
    <Footer v-if="showFooter"></Footer>
  </div>
</template>
<script>
import {
  downloadChrome
} from '@/store/electric_download'
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'ProcessNav',
  data () {
    return {
      value:'',
      lang:null,
      showTipsBox:false,
      showFooter:false,
      logo_cn:false,
      logo_en:false,
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    sessionStorage.clear();
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    if (isIE) {
      this.showTipsBox = true;
    }
    /* 英文版设置 */
    /* const language = localStorage.getItem('lang')
    this.handleCommand(language)
    if(!language) {
      this.handleCommand('en')
    } */
    /* 中文版设置 */
    const language = localStorage.getItem('lang')
    this.handleCommand(language)
    if(!language) {
      this.handleCommand('cn')
    }
  },
  methods: {
    openFile(){
      window.open("/#/fileDownLoad")
    },
    //语言切换
    handleCommand(e) {
      localStorage.setItem('lang',e);
      this.lang = e;
      this.$i18n.locale = e;
      // 设置全局语言参数
      if(e === 'cn') {
        this.showFooter = true
        this.logo_cn = true
        this.logo_en = false
      }else if(e === 'en') {
        this.showFooter = false
        this.logo_en = true
        this.logo_cn = false
      }
    },
    //下载浏览器
    download(){
      downloadChrome();
    }
  }
}
</script>

<style scoped>
  .img_box img{
    width:300px;
  }
  .tipsBox {
    position: fixed;
    width:100%;
    height:40px;
    left:0px;
    top:0px;
    background-color:#142479;
    margin:0 auto;
    text-align: center;
    color:white;
    line-height: 35px;
  }
  .tipsBox .text {
    display: inline-block;
    padding-right:20px;
  }
  .tipsBox .download {
    width:70px;
    height:25px;
    background: #e5e9f2;
    display: inline-block;
    border: 0;
    outline: none;
  }
  .center_box {
    width:70%;
    margin:0 auto;
    height:100%;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #FFFFFF;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 10px;
    min-height: 36px;
    height: 450px;
  }
  .grid-content:hover {
    transform: scale(1.05);
    background: #142479;
    cursor: pointer;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 100px;
  }
  .grid-content h1 {
    color:#333333;
    text-align: center;
    padding-top: 50px;
  }
  .grid-content img {
    display: block;
    margin: 0 auto;
    width: 112px;
    height: 112px;
    padding-top: 100px;
  }
  .grid-content:hover h1{
    color: white;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  /* 针对小屏幕样式优化 */
  @media screen and (max-width: 1367px) {
    .grid-content {
      border-radius: 10px;
      min-height: 36px;
      height: 330px;
    }
    .grid-content img {
      display: block;
      margin: 0 auto;
      width: 112px;
      height: 112px;
      padding-top: 70px;
    }
    .grid-content h1 {
      color:#333333;
      text-align: center;
      padding-top: 30px;
      font-size:20px;
    }
    .el-breadcrumb {
      font-size: 20px;
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ProcessNav.vue